import type {TicketStatus} from '../types/ticket';

/**
 * The board's columns, left to right in the order a ticket moves through them.
 *
 * Every status gets a column, including the settled ones. A board whose columns do not
 * account for every ticket is a board that lies: the header counts the whole queue, so
 * a ticket with no column to sit in simply goes missing, and the reader is left to work
 * out why five tickets show as three cards. Dragging a card to `resolved` is also the
 * most natural way to resolve one.
 *
 * Column labels are not held here: they come from `STATUS_LABELS`, so the board and
 * the list cannot end up calling the same status two different things.
 */
export const BOARD_STATUSES: readonly TicketStatus[] = [
	'open',
	'in_progress',
	'waiting_on_customer',
	'resolved',
	'closed',
] as const;
